var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myplayerfather"},[_c('div',{ref:"myplayer",attrs:{"className":"prism-player","id":"J_prismPlayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }